module.exports = __webpack_public_path__ + "img/pixnet_logo.a6c2254.svg";